import { createContext } from "react";

/*
Holds whether the current user is authenticated (has a valid access token).
Consumed by providers that must only run authenticated-only side effects
(e.g. push notification subscription) once the user is logged in.
*/

const AuthContext = createContext<boolean>(false);

export default AuthContext;
